import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { Seo, SITE_URL } from "./Seo";
import JsonData from "../data/data.json";

export const ServicesDetail = () => {
  const { slug } = useParams();
  const service = JsonData?.Services.find((item) => item.slug === slug);

  if (!service) {
    return (
      <div id="service-detail">
        <Seo
          path={`/services/${slug}`}
          title="Service Not Found | Pandobit"
          description="The service you are looking for could not be found."
          noindex
        />
        <div className="container text-center" style={{ padding: '80px 0' }}>
          <h2>Service Not Found</h2>
          <Link to="/#services" onClick={() => scroll.scrollToTop()} className="btn btn-custom btn-lg" style={{ marginTop: 24 }}>
            Back to Services
          </Link>
        </div>
      </div>
    );
  }

  const serviceSchema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: service.name,
    description: service.text,
    image: `${SITE_URL}/${service.image}`,
    url: `${SITE_URL}/services/${slug}`,
    provider: { "@type": "Organization", name: "Pandobit", url: SITE_URL },
    areaServed: "Worldwide",
  };

  return (
    <div id="service-detail">
      <Seo
        path={`/services/${slug}`}
        title={`${service.name} | Pandobit`}
        description={service.text}
        image={`${SITE_URL}/${service.image}`}
        jsonLd={serviceSchema}
      />
      <div className="service-detail-hero">
        <img src={`../${service.image}`} alt={service.name} />
        <div className="service-detail-hero-overlay">
          <div className="container">
            <h1>{service.name}</h1>
          </div>
        </div>
      </div>

      <div className="container service-detail-body">

        <section className="service-detail-section">
          <p className="service-detail-intro">{service.text}</p>
          {service.detail && <p className="service-detail-full">{service.detail}</p>}
        </section>

        {service.features && (
          <section className="service-detail-section">
            <h2>What We Offer</h2>
            <ul className="service-features-list">
              {service.features.map((feature, i) => (
                <li key={i}>
                  <i className="fa fa-check-circle"></i>
                  {feature}
                </li>
              ))}
            </ul>
          </section>
        )}

        {service.process && (
          <section className="service-detail-section">
            <h2>Our Process</h2>
            <div className="service-process">
              {service.process.map((step, i) => (
                <div className="service-process-step" key={i}>
                  <div className="step-number">{i + 1}</div>
                  <div className="step-content">
                    <h3>{step.step}</h3>
                    <p>{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}

        {service.benefits && (
          <section className="service-detail-section">
            <h2>Key Benefits</h2>
            <div className="service-benefits">
              {service.benefits.map((benefit, i) => (
                <div className="service-benefit-card" key={i}>
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              ))}
            </div>
          </section>
        )}

        <section className="service-detail-bridge">
          <p className="service-bridge-label">Let's build something together</p>
          <h2>
            Have a project in mind?<br />
            Tell us about it.
          </h2>
          <p className="service-bridge-sub">
            Our team typically responds within one business day — drop us a message below and let's start the conversation.
          </p>
          <div className="service-bridge-arrow">
            <i className="fa fa-angle-down"></i>
          </div>
        </section>

      </div>
    </div>
  );
};
